import { render, staticRenderFns } from "./FarmReports.vue?vue&type=template&id=4dfda9c9&scoped=true"
import script from "./FarmReports.vue?vue&type=script&lang=js"
export * from "./FarmReports.vue?vue&type=script&lang=js"
import style0 from "./FarmReports.vue?vue&type=style&index=0&id=4dfda9c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfda9c9",
  null
  
)

export default component.exports